import { Controller } from '@hotwired/stimulus';

/**
 * eKYC完了ページのカウントダウン・自動リダイレクトを管理するコントローラー
 *
 * 使用方法:
 * <div data-controller="ekyc-complete"
 *      data-ekyc-complete-redirect-url-value="/mypage"
 *      data-ekyc-complete-seconds-value="10">
 *   <span data-ekyc-complete-target="countdown">10</span>
 * </div>
 */
export default class extends Controller {
  static targets = ['countdown'];
  static values = {
    redirectUrl: String,
    seconds: { type: Number, default: 10 }
  };

  connect() {
    // 履歴を置換してブラウザバック防止
    history.replaceState(null, '', this.redirectUrlValue);

    this.remainingSeconds = this.secondsValue;
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  tick() {
    this.remainingSeconds--;

    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.remainingSeconds;
    }

    if (this.remainingSeconds <= 0) {
      clearInterval(this.timer);
      window.location.replace(this.redirectUrlValue);
    }
  }
}
